import { Star } from "lucide-react";

export const StarRating = ({ value = 0, size = 14, onChange, testid }) => (
  <div className="flex items-center gap-0.5" data-testid={testid}>
    {[1, 2, 3, 4, 5].map((n) => (
      <button
        key={n}
        type="button"
        disabled={!onChange}
        onClick={() => onChange?.(n)}
        data-testid={testid ? `${testid}-${n}` : undefined}
        className={onChange ? "cursor-pointer transition-transform hover:scale-110" : "cursor-default"}
        aria-label={`${n} stelle`}
      >
        <Star
          style={{ width: size, height: size }}
          className={n <= Math.round(value) ? "fill-amber-400 text-amber-600" : "text-stone-500"}
        />
      </button>
    ))}
  </div>
);
